export function TypographyGradientColor() {
  return (
    <h1 className="font-bold text-center leading-snug tracking-tight bg-gradient-to-tr from-slate-800 to-slate-500 bg-clip-text text-transparent mx-auto w-full text-2xl lg:max-w-3xl lg:text-5xl">
      Material Tailwind
    </h1>
  );
}
